import { render, staticRenderFns } from "./TrafficProviders.vue?vue&type=template&id=22bc0c5e&"
import script from "./TrafficProviders.vue?vue&type=script&lang=js&"
export * from "./TrafficProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports